export default {
  portal: {
    login: {
      username: "用户名_tw",
      inputUsername: "请输入用户名_tw",
      password: "密码_tw",
      inputPassword: "请输入密码_tw",
      checkCode: "验证码_tw",
      inputCheckCode: "请输入验证码_tw",
      loginText: "登录_tw",
      usernameNotEmpty: "用户名不能为空_tw",
      passwordNotEmpty: "密码不能为空_tw"
    }
  }
}